const LOCAL_CONFIG_URL = `/env.local.json`;

const getLocalConfig = async <T>(): Promise<T> => {
	const response = await fetch(LOCAL_CONFIG_URL);
	if (!response.ok)
		throw new Error(`Failed to load config from ${LOCAL_CONFIG_URL}: ${response.status} ${response.statusText}`);
	const config = (await response.json()) as T;
	if (!config) throw new Error(`No configuration found in ${LOCAL_CONFIG_URL}`);
	return config;
};

export const getConfig = async <T>(isDev: boolean, getConfigFromWindow: (w: Window) => T): Promise<T> => {
	const useLocalConfig = isDev || import.meta.env.VITE_USE_LOCAL_CONFIG === 'true';

	if (useLocalConfig) {
		return Object.freeze(await getLocalConfig<T>());
	}

	return Object.freeze(getConfigFromWindow(window));
};
